import { render } from "./ViewModelAnswerComponent.vue?vue&type=template&id=06f9535e&scoped=true"
import script from "./ViewModelAnswerComponent.vue?vue&type=script&lang=js"
export * from "./ViewModelAnswerComponent.vue?vue&type=script&lang=js"

import "./ViewModelAnswerComponent.vue?vue&type=style&index=0&id=06f9535e&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f9535e"]])

export default __exports__